

pagerController = ($element) ->
    'ngInject'

    @tagList = $element.controller('dybTagpickerTagList')
    @tagPicker = $element.controller('dybTagPicker')
    @id = "#{@tagList.tagGroup.slug}_#{@direction}"
    $element.addClass(@direction)

    @show = ->
        group = @tagList.tagGroup
        if @direction == 'next' then return group.hasNextPage
        else return group.hasPreviousPage and group.allowPage

    @tagCount = ->
        group = @tagList.tagGroup
        if @direction == 'prev' then return group.offset
        else return group.tags.length - group.offset - group.limit

    @click = ->
        group = @tagList.tagGroup
        if @direction == 'next' and not group.allowPage then group.more()
        else if @direction == 'next' then group.nextPage()
        else group.previousPage()
        return

    return


pagerDirective = ->
    'ngInject'

    restrict: 'E'
    templateUrl: 'util/tags/pickerPager'
    scope: direction: '@'
    controller: pagerController
    controllerAs: 'ctrl'
    bindToController: true
    require: '^dybTagpickerTagList'

module.directive 'dybTagpickerPager', pagerDirective